import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { ArrowRight, Sparkles } from 'lucide-react';
export const Hero = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  // Create a subtle floating animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIsSpinning(true);
      setTimeout(() => setIsSpinning(false), 2000);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section id="home" className="w-full bg-gradient-to-b from-white to-gray-50 py-16 md:py-24 overflow-hidden scroll-mt-20" data-id="element-120">
      <div className="container mx-auto px-4" data-id="element-121">
        <div className="flex flex-col md:flex-row items-center" data-id="element-122">
          {/* Hero Content */}
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-123">
            <div className="relative" data-id="element-124">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 leading-tight mb-6" data-id="element-125">
                Make Your{' '}
                <span className="text-[#00b8c4] relative" data-id="element-126">
                  Ideas
                  <span className="absolute -top-6 -right-6" data-id="element-127">
                    <Sparkles className={`h-6 w-6 text-[#ffcc29] ${isSpinning ? 'animate-spin' : ''}`} data-id="element-128" />
                  </span>
                </span>{' '}
                Stick!
              </h1>
            </div>
            <p className="text-xl text-gray-600 mb-8 max-w-lg" data-id="element-129">
              Custom stickers that bring your creativity to life. High-quality,
              weather-resistant, and perfectly cut to your design.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-130">
              <Button size="large" className="flex items-center group relative overflow-hidden" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-131">
                <span className="relative z-10 flex items-center" data-id="element-132">
                  Create Your Sticker
                  <ArrowRight className={`ml-2 h-5 w-5 transition-transform duration-300 ${isHovered ? 'transform translate-x-1' : ''}`} data-id="element-133" />
                </span>
                <span className="absolute inset-0 bg-[#008e98] transform -translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-134"></span>
              </Button>
              <Button primary={false} size="large" className="relative overflow-hidden group" data-id="element-135">
                <span className="relative z-10" data-id="element-136">Browse Templates</span>
                <span className="absolute inset-0 bg-[#ffb700] transform translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-137"></span>
              </Button>
            </div>
          </div>
          {/* Hero Images */}
          <div className="md:w-1/2 relative" data-id="element-138">
            <div className="relative z-10 transform rotate-3 hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-pointer" onMouseEnter={() => setIsSpinning(true)} onMouseLeave={() => setIsSpinning(false)} data-id="element-139">
              <img src="https://images.unsplash.com/photo-1572375992501-4b0892d50c69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80" alt="Laptop with stickers" className="rounded-lg shadow-xl" data-id="element-140" />
              <div className="absolute -bottom-4 -right-4 bg-[#ffcc29] rounded-full p-4 shadow-lg animate-pulse" data-id="element-141">
                <span className="text-gray-800 font-bold" data-id="element-142">Fast Shipping!</span>
              </div>
            </div>
            <div className="absolute top-1/4 -left-8 z-0 transform -rotate-6 hidden md:block hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-pointer" data-id="element-143">
              <img src="https://images.unsplash.com/photo-1589384267710-7a170981ca78?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80" alt="Water bottle with stickers" className="rounded-lg shadow-xl w-48 h-auto" data-id="element-144" />
            </div>
            {/* Floating stickers */}
            <div className="absolute -top-10 right-10 animate-bounce hidden md:block" data-id="element-145">
              <div className="h-16 w-16 rounded-full bg-[#ff6b6b] shadow-lg flex items-center justify-center text-white font-bold transform rotate-12" data-id="element-146">
                20% OFF
              </div>
            </div>
            <div className="absolute bottom-10 right-0 animate-pulse delay-300 hidden md:block" data-id="element-147">
              <div className="h-12 w-12 rounded-full bg-[#00b8c4] shadow-lg" data-id="element-148"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};